import React from 'react';
import { scrollToCompra } from '../utils/scroll';
interface ButtonProps {
  children: React.ReactNode;
  onClick?: (e: React.MouseEvent) => void;
  href?: string;
  className?: string;
  pulse?: boolean;
  fullWidth?: boolean;
}
export function Button({
  children,
  onClick,
  href,
  className = '',
  pulse = true,
  fullWidth = true
}: ButtonProps) {
  const baseClasses = 'relative inline-flex items-center justify-center font-montserrat font-black text-white bg-brand-primary hover:bg-brand-primaryDark transition-all duration-300 rounded-xl shadow-[0_6px_0_#0052CC] hover:shadow-[0_3px_0_#0052CC] hover:translate-y-[3px] active:shadow-none active:translate-y-[6px] px-4 py-4 md:px-8 md:py-5 text-lg md:text-xl lg:text-2xl text-center uppercase tracking-wide border-b-2 border-white/20';
  const pulseClasses = pulse ? 'animate-pulse-fast hover:animate-none' : '';
  const widthClasses = fullWidth ? 'w-full' : '';
  const handleClick = (e: React.MouseEvent) => {
    if (onClick) {
      onClick(e);
    } else if (!href) {
      scrollToCompra(e);
    }
  };
  if (href) {
    return <a href={href} className={`${baseClasses} ${pulseClasses} ${widthClasses} ${className}`} target="_blank" rel="noopener noreferrer" data-id="element-37">
        {children}
      </a>;
  }
  return <button onClick={handleClick} className={`${baseClasses} ${pulseClasses} ${widthClasses} ${className}`} data-id="element-38">
      {children}
    </button>;
}